<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <router-link class="btn btn-primary" to="/dashboard/splash">add new item</router-link>
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>پلتفرم</th>
                    <th>اخرین ورژن</th>
                    <th>بروز رسانی اجباری</th>
                    <th>وضعیت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="splash in splashes" :key="splash._id">
                    <td>{{ splash.platform }}</td>
                    <td>{{ splash.version }}</td>
                    <td>{{ splash.isForce ? 'بله' : 'خیر' }}</td>
                    <td>{{ splash.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/splash', query: { id: splash._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->
  </div>
</template>

<script>
import splashService from '../../../../services/Splash';
export default {
  name: 'league',
  data() {
    return {
      splashes: [],
    };
  },
  created() {
    this.getLicenses({});
  },
  methods: {
    async getLicenses(conditions) {
      try {
        const splashes = await splashService.getSplashs(conditions);
        this.splashes = splashes;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
